
import { pathOr, filter } from "ramda";
import { mapState } from "vuex";
// import ClickOutside from "vue-click-outside"; //  not needed anymore with new UI

const filterItems = filter(pathOr(false, ["targetVariantId"]));

export default {
  // directives: { ClickOutside },  not needed with new UI

  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    variants: { type: Object, required: true },
    label: { type: String, default: "" },
  },

  data() {
    return {
      internalSelectedTile: this.selectedTile,
      // active: false, not needed with new UI
    };
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
    bases() {
      return filterItems(this.tiles);
    },
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    getPrice(variantId) {
      return pathOr("", ["variants", variantId, "price"], this);
    },
    getDisplayLabel(tileLabel) {
      return tileLabel.replace(/base/gi, "").trim();
    },
    handleClick(tileLabel) {
      if (this.variantLoading) {
        return;
      }

      const tile = this.bases.find(element => element.tileLabel == tileLabel);

      this.$emit(
        "select-variant-id",
        tile.targetVariantId,
        this.label,
        tileLabel
      );
    },

    // to be removed after dropdown is removed
    // hide() {
    //   this.active = false;
    // },
  },
};
